import React from "react";
import { trackEvent } from "@/services/analytics";
import "./MlsSignInCta.scss";

const BLS_SITE_URL = process.env.REACT_APP_BLS_MARKETING_URL || "https://thebuyerlistingservice.com";

export const getMlsSignInUrl = (source, base = BLS_SITE_URL) =>
  `${String(base).trim().replace(/\/+$/, "")}/login?utm_source=gitcha&utm_medium=referral&utm_campaign=${encodeURIComponent(`${source || "auth"}_modal`)}`;

const MlsSignInCta = ({ source }) => (
  <a
    className="mls-signin-cta"
    href={getMlsSignInUrl(source)}
    onClick={() => trackEvent({ name: "gitcha_mls_signin_clicked", attributes: { source } })}
  >
    <span className="mls-signin-cta__text">
      <span className="mls-signin-cta__eyebrow">Real estate agent?</span>
      <span className="mls-signin-cta__label">Sign in to The Buyer Listing&nbsp;Service&reg;</span>
    </span>
    <svg className="mls-signin-cta__arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </a>
);

export default MlsSignInCta;
